var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { ExternalDamageComponent } from '@declaration/components/externalDamage/ExternalDamageComponent';
import { LIGHT_SOURCE_TYPE_CHOICES } from '@shared/constants/externalDamages';
import { LIGHT_SOURCE_TYPE_TITLE } from '@declaration/constants/externalDamages';
let LightSource = class LightSource extends ExternalDamageComponent {
    get title() {
        return this.translateExternalDamageKey(LIGHT_SOURCE_TYPE_TITLE);
    }
    get typeChoices() {
        return this.getExternalDamageChoices(LIGHT_SOURCE_TYPE_CHOICES);
    }
    get lightType() {
        var _a;
        return (_a = this.externalDamage.lightType) !== null && _a !== void 0 ? _a : null;
    }
    set lightType(lightType) {
        this.updateExternalDamage({ lightType });
    }
};
LightSource = __decorate([
    Component({ components: { RadioPrimaryButton } })
], LightSource);
export default LightSource;
